





































































































import Component from "vue-class-component";
import SearchButton from "front-component/components/SearchButton.vue";
import ViewList from "@/views/List.vue";
import RequestList from "@/components/request/list/List.vue";
import TopicSearch from "@/components/forms/search/request/TopicSearch.vue";
import KeywordSearch from "@/components/forms/search/KeywordSearch.vue";
import MultipleSelectSearch from "@/components/forms/search/MultipleSelectSearch.vue";
import SelectSearch from "@/components/forms/search/SelectSearch.vue";
import _ from "lodash";
import EventBus from "front-component/EventBus";
import {Prop, Watch} from "vue-property-decorator";
import * as Constants from "@/Constants";
import {Action, Getter} from "vuex-class";
import {User} from "front-component/modules/User";
import {Type} from "@/modules/request/Type";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import BudgetSearch from "@/components/forms/search/request/BudgetSearch.vue";
import {Filters} from "@/modules/request/RequestFilters";
import Http from "front-component/Http";

const components = {
    SearchButton,
    RequestList,
    KeywordSearch,
    TopicSearch,
    SelectSearch,
    MultipleSelectSearch,
    SelectOwner,
    BudgetSearch
};

export interface Option {
    key: string;
    label: string;
    deep?: number;
    hidden?: boolean;
    disabled?: boolean;
}


@Component({components})
export default class List extends ViewList {
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string | null;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getOwnerWorkflow") public getOwnerWorkflow!: (isClient: boolean) => any[];
    @Getter("getTopicScopeOwners") public topicScopeOwners!: string[];
    @Getter("getRequesters") public requesters!: User[];
    @Getter("getAssignedUsers") public assignedUsers!: User[] | null;
    @Getter("getTypes") public types!: Type[];
    @Getter("getRequestFilters") public filters!: Filters;
    @Action("updateRequestFilters") public updateFilter!: (filters: Filters) => void;
    @Action("initializeRequestFilters") public initializeRequestFilters!: (filters: Filters | null) => void;

    protected orders: object | any = {};

    private filteredScopeOwnerUuid: string | null = null;
    private optionsStatus: Option[] = [...Constants.optionsStatusRequest];
    private optionsRequesters: Option[] = [];
    private optionsAssigned: Option[] = [];
    private optionsRequestType: Option[] = [];
    private showScopeOwnerSelect: boolean = true;
    private exportDisabled: boolean = false;
    private isSimplified: boolean = false;
    private openedStatusKey: string = Constants.openedStatus.key;

    @Watch("filters.status") private updateStatus(newValue: string[], oldValue: string[]) {
        const selectableList = [
            Constants.openedStatus.key,
            Constants.requestStatus.completed,
            Constants.requestStatus.cancelled
        ];
        let isDifferencesOpened = false;

        _.forEach(newValue, (status: string) => {
            if (!_.includes(selectableList, status)) {
                isDifferencesOpened = true;
            }
        });
        if (isDifferencesOpened && _.includes(oldValue, Constants.openedStatus.key)) {
            const filteredArray = _.filter(this.filters.status, (status: string) => {
                return status !== Constants.openedStatus.key;
            });
            this.filters.status.splice(0, this.filters.status.length, ...filteredArray);
        }

        const isRestrained = _.includes(newValue, Constants.openedStatus.key);

        if (isRestrained) {
            _.remove(this.filters.status, (status: string) => {
                return !_.includes(selectableList, status);
            });
        }
    }

    public created() {
        if (!this.currentOwnerUuid) {
            return;
        }
        this.initializeRequestFilters(this.defaultFilters());

        this.$nextTick(() => {
            this.updateFilter(this.filters);
        });
    }

    public mounted() {
        this.setOptionsRequesters();
        this.setOptionsAssigned();
        this.setOptionsRequestType();
        this.setOptionsStatus();

        if (!this.currentOwnerUuid) {
            return;
        }

        if (_.get(this.filters, "ownerUuid.uuid", null) !== this.currentOwnerUuid) {
            const newFilters = this.defaultFilters();
            newFilters.ownerUuid.uuid = this.currentOwnerUuid ? this.currentOwnerUuid : "";
            this.resetRequestFilters(this.defaultFilters());
            this.updateFilter(this.defaultFilters());
            EventBus.$emit(
                "update-filter",
                _.set({}, "forceReload", !_.get(this.filters, "forceReload", false))
            );
        }
        EventBus.$on("request-status-updated", this.refreshList);
        EventBus.$on("request-assigned-updated", this.refreshList);
    }

    public beforeDestroy(): void {
        EventBus.$off("request-status-updated", this.refreshList);
        EventBus.$off("request-assigned-updated", this.refreshList);
    }

    private defaultFilters(): Filters {
        return {
            keyword: "",
            right: "",
            status: [this.openedStatusKey],
            main_request: true,
            allocationTypeOrBudget: null,
            scopeOwnerUuid: null,
            hierarchyOwner: null,
            topic: null,
            ownerUuid: {
                uuid: this.currentOwnerUuid
            }
        };
    }

    private updateHierarchyFilter(selectedOwner: string): void {
        EventBus.$emit("update-filter", _.set({}, "hierarchyOwner", selectedOwner));
    }

    private updateScopeFilter(selectedOwnerUuid: string): void {
        this.filteredScopeOwnerUuid = selectedOwnerUuid;

        if (_.find(this.topicScopeOwners, (line) => {
            return line === selectedOwnerUuid;
        })) {
            EventBus.$emit("update-filter", _.set({}, "scopeOwnerUuid", selectedOwnerUuid));
        }
    }

    private exportRequest(): void {
        this.exportDisabled = true;
        const params = {filters: this.filters, orders: this.orders};
        Http.download(
            "/exportrequest",
            params,
            (data: Blob) => {
                const url = window.URL.createObjectURL(data);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Export Requests.csv");
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.exportDisabled = false;
            },
            () => {
                this.$message({
                    message: _.invoke(this.$options.filters, "trans", "errorDownloadDocument"),
                    type: "error"
                });
                this.exportDisabled = false;
            }
        );
    }

    @Watch("currentOwnerUuid")
    private refreshList(newUuid: string | null, oldUuid: string | null): void {
        this.setOptionsStatus();

        this.$nextTick(() => {
            if (!this.$el || !this.$el.parentNode) {
                return;
            }
            const newFilters = this.defaultFilters();
            newFilters.ownerUuid.uuid = newUuid;
            this.resetRequestFilters(newFilters);
            this.updateFilter(newFilters);

            EventBus.$emit(
                "update-filter",
                _.set({}, "forceReload", !_.get(this.filters, "forceReload", false))
            );
        });
    }

    @Watch("requesters") private updatedRequesters(): void {
        this.setOptionsRequesters();
    }

    @Watch("assignedUsers") private updatedAssignedUsers(): void {
        this.setOptionsAssigned();
    }

    @Watch("types") private updatedTypes(): void {
        this.setOptionsRequestType();
    }

    @Watch("filters.status") private updatedStatus(): void {
        if (!this.filters) {
            return;
        }
        if (this.isSimplified) {
            _.set(this.filters, "distinct_request", true);
        } else {
            if (this.filters.hasOwnProperty("distinct_request")) {
                delete this.filters.distinct_request;
            }
        }
    }

    private setOptionsRequestType(): void {
        const options: Option[] = [];
        _.forEach(this.types, (type: Type) => {
            options.push({key: type.uuid, label: type.label});
        });
        this.optionsRequestType = options;
    }

    private setOptionsRequesters(): void {
        const options: Option[] = [];
        _.forEach(this.requesters, (line: User) => {
            options.push({key: line.displayName, label: line.displayName});
        });
        this.optionsRequesters = options;
    }

    private setOptionsAssigned(): void {
        const options: Option[] = [];
        options.push({key: "noAssigned", label: _.invoke(this.$options.filters, "trans", "requestNotAssigned")});
        _.forEach(this.assignedUsers, (line: User) => {
            options.push({key: line.displayName, label: line.displayName});
        });
        this.optionsAssigned = options;
    }

    private setOptionsStatus(): void {
        const requestStatusClientSM = this.getOwnerWorkflow(true);

        _.forEach(this.optionsStatus, (status) => {
            status.hidden = !_.has(requestStatusClientSM, status.key) && _.get(status, "tag", false);
        });
    }

    private toggleScopeOwnerSelectVisibility(nbScopeOwnerOptions: number): void {
        this.showScopeOwnerSelect = 1 !== nbScopeOwnerOptions;
    }

    private switchList(isSimplified: boolean) {
        this.isSimplified = isSimplified;

        const updated = {
            ...this.filters,
            main_request: !isSimplified
        };
        if (isSimplified) {
            updated.distinct_request = true;
        } else {
            delete updated.distinct_request;
        }
        this.updateFilter(updated);
    }
}
